export function mixin(target, ...sources) {
	sources.forEach(source => {
		Object.getOwnPropertyNames(source.prototype).forEach(name => {
			if (name !== 'constructor') {
				Object.defineProperty(target.prototype, name, Object.getOwnPropertyDescriptor(source.prototype, name));
			}
		});
	});
}